/**
 * CTS Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import FileDto from './FileDto';

/**
 * The BookFileItemNoRefDto model module.
 * @module model/BookFileItemNoRefDto
 * @version v1.0.0
 */
class BookFileItemNoRefDto {
    /**
     * Constructs a new <code>BookFileItemNoRefDto</code>.
     * @alias module:model/BookFileItemNoRefDto
     */
    constructor() { 
        
        BookFileItemNoRefDto.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>BookFileItemNoRefDto</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/BookFileItemNoRefDto} obj Optional instance to populate.
     * @return {module:model/BookFileItemNoRefDto} The populated <code>BookFileItemNoRefDto</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new BookFileItemNoRefDto();

            if (data.hasOwnProperty('bookIsbn')) {
                obj['bookIsbn'] = ApiClient.convertToType(data['bookIsbn'], 'String');
            }
            if (data.hasOwnProperty('bookType')) {
                obj['bookType'] = ApiClient.convertToType(data['bookType'], 'String');
            }
            if (data.hasOwnProperty('coverFile')) {
                obj['coverFile'] = FileDto.constructFromObject(data['coverFile']);
            }
            if (data.hasOwnProperty('extension')) {
                obj['extension'] = ApiClient.convertToType(data['extension'], 'String');
            }
            if (data.hasOwnProperty('filename')) {
                obj['filename'] = ApiClient.convertToType(data['filename'], 'String');
            }
            if (data.hasOwnProperty('id')) {
                obj['id'] = ApiClient.convertToType(data['id'], 'String');
            }
            if (data.hasOwnProperty('md5')) {
                obj['md5'] = ApiClient.convertToType(data['md5'], 'String');
            }
            if (data.hasOwnProperty('url')) {
                obj['url'] = ApiClient.convertToType(data['url'], 'String');
            }
        }
        return obj;
    }


}

/**
 * Book Id
 * @member {String} bookIsbn
 */
BookFileItemNoRefDto.prototype['bookIsbn'] = undefined;

/**
 * Book Type
 * @member {String} bookType
 */
BookFileItemNoRefDto.prototype['bookType'] = undefined;

/**
 * @member {module:model/FileDto} coverFile
 */
BookFileItemNoRefDto.prototype['coverFile'] = undefined;

/**
 * File extension
 * @member {String} extension
 */
BookFileItemNoRefDto.prototype['extension'] = undefined;

/**
 * File name
 * @member {String} filename
 */
BookFileItemNoRefDto.prototype['filename'] = undefined;

/**
 * File id
 * @member {String} id
 */
BookFileItemNoRefDto.prototype['id'] = undefined;

/**
 * md5
 * @member {String} md5
 */
BookFileItemNoRefDto.prototype['md5'] = undefined;

/**
 * url
 * @member {String} url
 */
BookFileItemNoRefDto.prototype['url'] = undefined;






export default BookFileItemNoRefDto;

